// Generated by CoffeeScript 2.7.0
var BASE_FIELDS, SettingsCustomerService;

import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js';

import FieldList from 'trunks/vue/admin/components/response_fields/list/fieldable.js';

BASE_FIELDS = [
  {
    id: -1,
    title: '客服文案',
    description: '提示用户接入客服系统',
    key: 'customer_service_prompt',
    type: 'Field::TextArea',
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -2,
    title: '客服关键字',
    description: '当用户的输入内容包含关键字，即可接入客服系统',
    key: 'customer_service_reg',
    type: 'Field::TextField',
    settings: {
      layout: null
    },
    _editing: true
  }
];

export default SettingsCustomerService = Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    'field-list': FieldList
  },
  props: {
    activeTab: {
      type: String
    },
    customerService: {
      type: Object
    }
  },
  data: function() {
    return {
      settingsCustomerService: this._generateCustomerService(),
      updateDisabled: false
    };
  },
  template: `<settings-container :activeTab="activeTab">
  <template slot="content">
    <div class="form-field-group field-list-two-item inline">
      <div class="form-field inline">
        <div class="form-field-head">
          <div class="form-field-title">客服功能</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <label class="switch">
              <input type="checkbox" v-model='settingsCustomerService.customer_service_enable'>
              <span></span>
            </label>
          </div>
          <div class="message"></div>
        </div>
      </div>
      <div class="form-field"></div>
    </div>
    <field-list v-show="settingsCustomerService.customer_service_enable"
                :fields="baseAttributefields"
                :response="baseAttributeResponse"
                :entries="baseAttributeResponse.entries"
                :editing="true"
                extendClass="form-field-group field-list-two-item inline"
                ref="baseAttributesRef" />
    <div class="content-footer">
      <button class="content-footer-btn" :disabled="updateDisabled" @click="updateSettings">更新</button>
    </div>
  </template>
</settings-container>`,
  computed: {
    baseAttributefields: function() {
      return _.map(BASE_FIELDS, (item) => {
        return this._createTypeField(item);
      });
    },
    baseAttributeResponse: function() {
      return new Skylark.App.Model.Response({
        id: '_settings_response',
        entries: [
          {
            field_id: -1,
            value: this.customerService.customer_service_prompt
          },
          {
            field_id: -2,
            value: this.customerService.customer_service_reg
          }
        ]
      });
    }
  },
  methods: {
    updateSettings: function() {
      var data, entries;
      entries = this.$refs.baseAttributesRef.getEntries();
      this._transferEntries(entries);
      data = {
        namespace: {}
      };
      _.each(this.settingsCustomerService, function(item, key) {
        return data.namespace[key] = item;
      });
      return Skylark.Libs.Ajax.patch('/admin/settings/customer_service.json', {
        data: data,
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function(data) {
          return Skylark.Bridge.newAlertify('更新成功', {
            type: 'success'
          });
        },
        error: function(xhr, status, err) {
          return Skylark.Bridge.newAlertify('更新失败', {
            type: 'danger'
          });
        },
        complete: () => {
          return this.updateDisabled = false;
        }
      });
    },
    _createTypeField: function(item) {
      return Skylark.App.Model.Field.Base.new(item, void 0, {});
    },
    _generateCustomerService: function() {
      return {
        customer_service_enable: this.customerService.customer_service_enable,
        customer_service_reg: this.customerService.customer_service_reg,
        customer_service_prompt: this.customerService.customer_service_prompt
      };
    },
    _transferEntries: function(entries) {
      return _.each(BASE_FIELDS, (field) => {
        var entry;
        entry = _.find(entries, function(entry) {
          return field.id === entry.field_id;
        });
        if (entry) {
          return this.settingsCustomerService[field.key] = entry.value;
        } else {
          return this.settingsCustomerService[field.key] = '';
        }
      });
    }
  }
});
